import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationProtectLogsCollection = GenericCollectionFactory("PMS_LOCATION_PROTECT_LOGS", "uid")
